import axios from 'lib/utils/axios';

import getCardList from 'api/requests/card/getCardList';
import getCardLimits from 'api/requests/card/getCardLimits';
import getBindingDetails from 'api/requests/card/getBindingDetails';

import logrocket from '@/services/logrocket';

const fetchCardList = async (state) => {
  try {
    const { data } = await getCardList(axios);

    state.commit('SET_CARD_LIST', data);
  } catch (error) {
    logrocket.logger(error);
    throw new Error;
  }
};

const fetchCardLimits = async (state) => {
  try {
    const { data } = await getCardLimits(axios);

    state.commit('SET_CARD_LIMITS', data);
  } catch (error) {
    logrocket.logger(error);
    throw new Error;
  }
};

const fetchBindingDetails = async (state) => {
  try {
    const { data } = await getBindingDetails(axios);

    state.commit('SET_BINDING_DETAILS', data);
  } catch (error) {
    logrocket.logger(error);
    throw new Error;
  }
};

export default {
  fetchCardList,
  fetchCardLimits,
  fetchBindingDetails,
};
